<div
  *transloco="let t"
  class="main-wrapper"
  [ngClass]="{
    'first-time': isFirstTime
  }"
>
  <!-- Logo -->
  <img class="logo" src="../../../assets/img/logo/logo_MojeiSophi_black.svg" alt="Moje iSophi" />

  <!-- First time visiting -->
  <ng-container *ngIf="isFirstTime">
    <!-- Get to know isophi section -->
    <section class="wrapper">
      <span class="wrapper-title">{{ t('home/knowIsophi') }}</span>

      <div class="card-wrapper">
        <!-- Demo kindergarten card -->
        <div class="content-card rose" *ngIf="showDemoSwitch$ | async">
          <div class="icon"><i class="material-symbols-rounded">manufacturing</i></div>
          <h2 class="text">{{ t('home/howEverythingWorks') }}</h2>
          <button class="btn btn-outline-primary" (click)="switchToDemoKindergarten()">{{ t('home/goToDemoKindergarten') }}</button>
        </div>
        <!-- Demo app card -->
        <div class="content-card green" *ngIf="hasTrial$ | async">
          <div class="icon"><i class="material-symbols-rounded">contextual_token</i></div>
          <h2 class="text">{{ t('home/tryApp') }}</h2>
          <a [routerLink]="links.homepage()" class="btn btn-outline-primary">{{ t('home/goToDemoVersion') }}</a>
        </div>
        <!-- Invite colleagues card -->
        <div class="content-card gray" *ngIf="isManager">
          <div class="icon"><i class="material-symbols-rounded">groups_2</i></div>
          <h2 class="text">{{ t('home/inviteColleaguesToApp') }}</h2>
          <a [routerLink]="links.userList()" class="btn btn-outline-primary">{{ t('home/inviteColleagues') }}</a>
        </div>
      </div>
    </section>

    <!-- You will find section -->
    <section class="wrapper">
      <span class="wrapper-title">{{ t('home/willFindInIsophi') }}</span>

      <ng-container *ngTemplateOutlet="appLinks"></ng-container>
    </section>
  </ng-container>

  <ng-container *ngIf="!isFirstTime">
    <ng-container *ngTemplateOutlet="appLinks"></ng-container>
  </ng-container>
</div>

<ng-template #appLinks>
  <div class="content-wrapper" *transloco="let t">
    <!-- Child portfolio -->
    <a class="content-container" *ngIf="showChildPortfolio$ | async" [routerLink]="links.childrenPortfolioDashboard()">
      <i class="material-symbols-rounded">face</i>
      <div class="spacer"></div>
      <div class="texts">
        <h2>{{ t('home/isophiChildPortfolio') }}</h2>
        <p>{{ t('home/isophiChildPortfolioText') }}</p>
      </div>
    </a>
    <!-- Management -->
    <a class="content-container" *ngIf="showManagement$ | async" [routerLink]="links.dashboard()">
      <i class="material-symbols-rounded">inventory</i>
      <div class="spacer"></div>
      <div class="texts">
        <h2>{{ t('home/management') }}</h2>
        <p>{{ t('home/managementText') }}</p>
      </div>
    </a>
    <!-- Diagnostics (teacher app) -->
    <a class="content-container" *ngIf="showTeacherApp$ | async" [href]="tAppUrl.url" [target]="tAppUrl.target">
      <i class="material-symbols-rounded">search_insights</i>
      <div class="spacer"></div>
      <div class="texts">
        <h2>{{ t('home/diagnostics') }}</h2>
        <p>{{ t('home/diagnosticsText') }}</p>
      </div>
    </a>
    <!-- Pap -->
    <ng-container *ngIf="showPap$ | async">
      <a class="content-container" [routerLink]="links.papPortfolio()" *ngIf="isManager">
        <ng-container *ngTemplateOutlet="support"></ng-container>
      </a>
      <a class="content-container" [href]="papAppUrl.url" [target]="papAppUrl.target" *ngIf="!isManager">
        <ng-container *ngTemplateOutlet="support"></ng-container>
      </a>
    </ng-container>
    <!-- Head office -->
    <a class="content-container" *ngIf="isManager" [routerLink]="links.kindergartenData()">
      <i class="material-symbols-rounded">business_center</i>
      <div class="spacer"></div>
      <div class="texts">
        <h2>{{ t('home/headOffice') }}</h2>
        <p>{{ t('home/headOfficeText') }}</p>
      </div>
    </a>

    <ng-template #support>
      <i class="material-symbols-rounded">person_heart</i>
      <div class="spacer"></div>
      <div class="texts">
        <h2>{{ t('home/support') }}</h2>
        <p>{{ t('home/supportText') }}</p>
      </div>
    </ng-template>
  </div>
</ng-template>
